(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-tab"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.blog-other-articles');
  if (!container) return;

  // Parse the JSON once
  const articles = JSON.parse(container.dataset.articles || '[]');
  const tabs = document.querySelectorAll('.tabs .tab');

  function renderArticles(tag) {
    container.innerHTML = ''; 

    const filtered = tag === 'all'
      ? articles
      : articles.filter(a => a.tags.split(',').map(t => t.trim()).includes(tag));

    filtered.forEach(article => {
      const card = document.createElement('div');
      card.className = 'blog-article-card';
      card.setAttribute('data-tags', article.tags);

      card.innerHTML = `
        ${article.image ? `<a href="${article.url}" class="thumb">
          <img src="${article.image}" alt="${article.title}">
        </a>` : ''}
        <div class="text">
          <span class="meta">${article.read_time} min <span>read</span> • ${article.date}</span>
          <h4><a href="${article.url}">${article.title}</a></h4>
          <p class="two-line">${article.excerpt}</p>
        </div>`;
      container.appendChild(card);
    });
  }

  // initial render
  renderArticles('all');

  // tab click event
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      renderArticles(tab.dataset.tag);
    });
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
